import { toast } from "components/ui/use-toast";
/**
 * Downloads a file from a Blob object.
 * @param {Blob} blob - The Blob object containing the file data.
 */

export const downloadFromBlob = (
    blob: Blob,
    fileName: string
) => {

    try {
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = fileName || "download.zip";
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        toast({
            description: "Erro ao processar e baixar o arquivo ZIP.",
            variant: "destructive",
        });
        console.error("Erro ao baixar o arquivo:", error);
    }
}